/**
 * @file poRevisions.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-09-30
 * @modified 2026-09-30
 *
 * What to offer to re-send after an order change reached POs a supplier (or
 * haulier) already holds — from the `po_changes` / `haulage_refreshed` an
 * order save or a quantity change returns. The revised email names the change
 * (SendPOEmailModal textFor reads `revision`).
 */

/**
 * What a re-sent PO's email says changed. A lone delivery-date change names the
 * new date in the subject; anything else is "amended", with the list in the
 * message.
 */
export function revisionFor(changes = []) {
  const list = (changes || []).filter(Boolean);
  const date = list.length === 1 && /^delivery date /.test(list[0]) ? list[0].split('→').pop().trim() : null;
  const pretty = (iso) => (/^\d{4}-\d{2}-\d{2}$/.test(iso) ? iso.split('-').reverse().join('/') : iso);
  return { summary: date ? `new delivery date ${pretty(date)}` : 'amended', changes: list };
}

/**
 * Sent POs a change reached, shaped for SendToSupplierFlow with their revision.
 * Only ones the supplier HOLDS (sent) and that still stand (not archived or
 * cancelled, not brand new) — a PO nobody has seen needs no revised copy.
 */
export function revisedPosFrom(result) {
  const changed = Array.isArray(result?.po_changes) ? result.po_changes : [];
  const refreshed = Array.isArray(result?.haulage_refreshed) ? result.haulage_refreshed : [];
  return [
    ...changed.filter(p => p.sent_to_contact && p.outcome === 'updated' && (p.changes || []).length),
    ...refreshed.filter(p => p.sent_to_contact && !['cancel', 'new'].includes(p.outcome))
  ].map(p => ({
    id: p.id,
    purchase_order_number: p.purchase_order_number,
    xero_purchase_order_id: p.xero_purchase_order_id,
    po_type: p.po_type,
    supplier_name: p.supplier_name,
    sent_to_contact: true,
    revision: revisionFor(p.changes)
  }));
}
